'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(DocumentStatus2) {
  DocumentStatus2["NOT_REQUESTED"] = "NOT_REQUESTED";
  DocumentStatus2["REQUESTED"] = "PENDING";
  DocumentStatus2["PROCESSING"] = "PROCESSING";
  DocumentStatus2["APPROVED"] = "APPROVED";
})(exports.DocumentStatus || (exports.DocumentStatus = {}));
